export default __webpack_public_path__ + "profile-link@2x.54976a21.png";